import { API, unwrapData } from '../axios-instance'
import { SetMediaObjectParams } from '../media/types'
import { EditLocaleParams, Locale, Tenant, TenantBanner, TenantLogo } from './types'

export const editTenantLocale = async (params: EditLocaleParams) => {
  return await API.post<Locale>('/identity/tenants/locale', params).then(r => r.data)
}

export const getTenantLocale = async () => {
  return await API.get<Locale>('/identity/tenants/locale').then(r => r.data)
}

export const getTenant = async (id: string) => {
  return await API.get<Tenant>(`/identity/tenants/${id}`).then(r => r.data)
}

export const setTenantLogo = async (tenantId: string, params: SetMediaObjectParams) => {
  return await API.post<TenantLogo>(`/identity/tenants/${tenantId}/logo`, params).then(unwrapData)
}

export const setTenantBanner = async (tenantId: string, params: SetMediaObjectParams) => {
  return await API.post<TenantBanner>(`/identity/tenants/${tenantId}/banner`, params).then(
    unwrapData,
  )
}

export const updateTenantName = async (tenantId: string, name: string) => {
  return await API.patch<Tenant>(`/identity/tenants/${tenantId}`, { name }).then(unwrapData)
}
